import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../../entries/common/request";
import { BaseApi } from "../../core/base-api";
import { makeDataMethod } from "../../core/base-api/methods-maker";
export var MeFacebookApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(MeFacebookApi, _BaseApi);

  var _super = _createSuper(MeFacebookApi);

  function MeFacebookApi() {
    _classCallCheck(this, MeFacebookApi);

    return _super.apply(this, arguments);
  }

  return MeFacebookApi;
}(BaseApi);
/**
 * TEMP not needed if using identity. send email verification to user's existing email address.
 */

MeFacebookApi.prototype.connect = makeDataMethod({
  method: 'post',
  path: Request.Me.Facebook.Paths.Connect,
  needAuth: true
});
/**
 * TEMP not needed if using identity. connect account to fb account
 */

MeFacebookApi.prototype.disconnect = makeDataMethod({
  method: 'post',
  path: Request.Me.Facebook.Paths.Disconnect,
  needAuth: true
});